import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SubscriptionBanner = ({ tier, propertyCount, propertyLimit }) => {
  const navigate = useNavigate();

  if (tier !== 'free') return null;

  const isAtLimit = propertyCount >= propertyLimit;

  return (
    <div className={`${isAtLimit ? 'bg-warning/10 border-warning/30' : 'bg-primary/5 border-primary/20'} border rounded-lg p-4 md:p-5 lg:p-6 mb-6 md:mb-8`}>
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex items-start gap-3 md:gap-4">
          <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${isAtLimit ? 'bg-warning/20' : 'bg-primary/10'}`}>
            <Icon 
              name={isAtLimit ? 'AlertCircle' : 'Zap'} 
              size={20} 
              color={isAtLimit ? 'var(--color-warning)' : 'var(--color-primary)'} 
              className="md:w-6 md:h-6"
            />
          </div>
          <div>
            <h4 className="text-base md:text-lg font-semibold text-foreground mb-1">
              {isAtLimit ? 'Property Limit Reached' : 'Free Plan Active'}
            </h4>
            <p className="text-sm md:text-base text-muted-foreground mb-2">
              {isAtLimit 
                ? `You've reached your limit of ${propertyLimit} property. Upgrade to add unlimited properties and unlock AI-powered features.`
                : `You're using ${propertyCount} of ${propertyLimit} property. Upgrade for unlimited properties, offers, and AI-powered insights.`
              }
            </p>
            <div className="flex flex-wrap items-center gap-3 md:gap-4 text-xs md:text-sm text-muted-foreground">
              <div className="flex items-center gap-1.5">
                <Icon name="Check" size={14} className="text-success md:w-4 md:h-4" />
                <span>1 Property</span>
              </div>
              <div className="flex items-center gap-1.5">
                <Icon name="Check" size={14} className="text-success md:w-4 md:h-4" />
                <span>2 Offers per property</span>
              </div>
              <div className="flex items-center gap-1.5">
                <Icon name="X" size={14} className="text-error md:w-4 md:h-4" />
                <span>No AI features</span>
              </div>
            </div>
          </div>
        </div>
        <Button
          variant={isAtLimit ? 'default' : 'outline'}
          size="lg"
          iconName="ArrowUpRight"
          iconPosition="right"
          onClick={() => navigate('/account?tab=subscription')}
          className="lg:flex-shrink-0"
        >
          Upgrade to Pro
        </Button>
      </div>
    </div>
  );
};

export default SubscriptionBanner;